import { getPhoneNumberField } from 'portal/src/components/common/forms/commonFormFields';
import {
  patternInputType,
  selectInputType,
  textInputType,
} from 'portal/src/components/common/forms/FormFieldTypes';

enum RequestType {
  Question = 'Question',
  ProductIssue = 'Product Issue',
  ProductIdea = 'Product Idea',
  AddDataAutomation = 'Add Data Automation',
  AddSmartMeter = 'Add Smart Meter',
  Other = 'Other',
}

export const defaultValues = () => ({
  requestType: '',
  name: '',
  phoneNumber: '',
  message: '',
});

export const getFields = (): (
  | patternInputType
  | textInputType
  | selectInputType
)[] => [
  {
    placeholder: 'Request Type',
    label: 'Request Type',
    name: 'requestType',
    type: 'selectInput',
    required: true,
    values: Object.values(RequestType).map((item) => ({
      label: item,
      value: item,
    })),
  },
  {
    placeholder: 'Name',
    label: 'Name',
    name: 'name',
    type: 'textInput',
    required: true,
  },
  getPhoneNumberField(true, 'phoneNumber'),
  {
    placeholder: 'Message',
    label: 'Message',
    name: 'message',
    type: 'textInput',
    required: true,
    multiline: true,
  },
];
